import { t } from "i18next";
import Skeleton from "react-loading-skeleton";
import { Selector } from "./Selector";

export const CycleSelect = ({
  label = t("cyclesAndGoals.cycle"),
  selectedCycle,
  selectHandler,
  cycles,
  interaction = true,
}) => {
  return (
    <Selector
      id="cycle-selector"
      label={label}
      assistiveText={t("cyclesAndGoals.cycleSelect")}
      selectHandler={selectHandler}
      options={cycles}
      selectedItemId={selectedCycle.id ?? ""}
      interaction={interaction}
    />
  );
};

export const CycleSelectDashboard = ({
  selectHandler,
  cycles,
  selectedCycle,
  loadedCycles,
}) => {
  return loadedCycles ? (
    <Selector
      id="cycle-selector"
      size="small"
      options={cycles.map((cycle) => ({ id: cycle.id, label: cycle.name }))}
      selectHandler={selectHandler}
      selectedItemId={selectedCycle?.id ?? ""}
      label={t("filter.cycle")}
    />
  ) : (
    <Skeleton
      count={1}
      style={{ width: "100%", height: 24, borderRadius: 5 }}
    />
  );
};
